import { FC } from 'react';
import { RiFileUserFill } from 'react-icons/ri';
import { LinkButton } from '../../components/shared/LinkButton';
import { TSTitleCard } from '../../components/shared/card/Card';
import { useGetMeQuery } from '../../services/gql/graphql.generated';
import strings from './myData.translations';

interface InformationUpToDateCardProps {}

export const informationUpToDateCardId = 'information-up-to-date-card';

export const InformationUpToDateCard: FC<InformationUpToDateCardProps> = () => {
  const [{ data }] = useGetMeQuery();
  const myUserId = data!.myEmployee!.identityId;

  return (
    <TSTitleCard
      id={informationUpToDateCardId}
      title={strings.infoUpToDateCard.title}
      descriptor={strings.infoUpToDateCard.gdpr}
      icon={RiFileUserFill}
    >
      <div>
        <p className="leading-5">{strings.infoUpToDateCard.description}</p>
        <div className="mt-4">
          <LinkButton to={`/team-member/${myUserId}`} className="flex flex-col w-max max-w-full">
            <p className="font-medium">{strings.personalInfo}</p>
            <p className="text-xs text-secondary-std">{strings.infoUpToDateCard.linkAdditionalInfo}</p>
          </LinkButton>
        </div>
      </div>
    </TSTitleCard>
  );
};
